import { Form } from "@unform/web";
import { useEffect, useState } from "react";

import { HTTPErrorCallback } from "Helpers/Error";

import { UseGlobalLoading } from "Hooks/UseGlobalLoading";
import UseServices from "Hooks/UseServices";

import Button from "Components/Admin/Buttons";

import CounterpartForm from "../CounterpartForm";
import * as S from "./styles";

const UpdateProjectCounterparts = ({ projectId, linkOptions }) => {
  const { api } = UseServices();
  const { loading } = UseGlobalLoading();

  // Lista FECHADA (D9 da parte 2, 03/09/2026): "Aprovado"/"Reprovado" saíram —
  // a contrapartida está pendente ou foi entregue. O backend valida a mesma
  // lista (@/config/counterpartStatuses), então divergir aqui dá erro 400.
  const [statusOptions] = useState([
    { label: "Pendente", value: "Pendente" },
    { label: "Entregue", value: "Entregue" },
  ]);

  const [counterparts, setCounterparts] = useState([]);
  const [selectedCounterpart, setSelectedCounterpart] = useState(null);

  useEffect(() => {
    if (projectId) return getProjectCounterparts(projectId);

    // eslint-disable-next-line
  }, [projectId]);

  const getProjectCounterparts = (project_id) => {
    api
      .post("/counterparts/get-counterparts-by-project-id", {
        project_id: project_id,
      })
      .then((response) => {
        const counterparts = response.data?.counterparts;

        setCounterparts(counterparts);
      })
      .catch((error) => {
        return HTTPErrorCallback(error);
      });
  };

  return (
    <S.Wrapper>
      {selectedCounterpart ? (
        <CounterpartForm
          projectId={projectId}
          selectedCounterpart={selectedCounterpart}
          setSelectedCounterpart={setSelectedCounterpart}
          linkOptions={linkOptions}
          statusOptions={statusOptions}
          getProjectCounterparts={getProjectCounterparts}
        />
      ) : null}
      <Form>
        <S.Section>
          <span>Contrapartidas</span>
          <hr />
        </S.Section>

        <S.Buttons>
          <div />

          <Button
            type="button"
            text="Criar Contrapartida"
            disabled={loading}
            onClick={() => setSelectedCounterpart(true)}
          />
        </S.Buttons>

        {!counterparts.length ? (
          <span>Nenhuma contrapartida cadastrada.</span>
        ) : null}

        {counterparts.map((counterpart) => (
          <S.Counterpart
            key={counterpart.id}
            onClick={() => setSelectedCounterpart(counterpart)}
          >
            <S.CounterpartInfos>
              {/* Sem o campo Nome (D10), a contrapartida se identifica pela
                  DESCRIÇÃO — é o que ficou no formulário. */}
              <h2>{counterpart.description}</h2>
              {/* Desde a parte 4 o rótulo é o mesmo do campo "Seletiva" do
                  formulário: patrocinador e, quando há, a seletiva do vínculo. */}
              <span>
                <strong>Seletiva:</strong>{" "}
                {counterpart.project_sponsor?.select_project?.sponsor?.name ||
                  counterpart.project_sponsor?.sponsor?.full_name ||
                  "Não Cadastrado"}
                {counterpart.project_sponsor?.select_project?.name
                  ? ` - ${counterpart.project_sponsor.select_project.name}`
                  : ""}
              </span>
              <span>
                <strong>Status:</strong> {counterpart.status}
              </span>
            </S.CounterpartInfos>
          </S.Counterpart>
        ))}
      </Form>
    </S.Wrapper>
  );
};

export default UpdateProjectCounterparts;
